export default "__VITE_ASSET__CiLbffPn__"